import GetInvoiceDataLocal from "./GetInvoiceDataLocal";
import * as actionType from "../../../context/actions";

const EditInvoiceDataInLocal = async (state, dispatch, id, invoiceData) => {

    try {

        // Retrieve existing invoices from localStorage
        const existingData = JSON.parse(localStorage.getItem("LOCAL_INVOICES")) || [];
        const invoiceIndex = existingData.findIndex((invoice, index) => invoice.uniqueID == id || index == id || invoice.id == id);

        const formatItems = (rawItems) => {
            return rawItems.map(i => ({
                // amount: i?.amount?.toString() || "0.00",
                // billId: invoiceData?.id?.toString() || "",
                // companyId: invoiceData?.companyId?.toString() || "",
                // creationDate: new Date(parseInt(invoiceData.creationDate)).getTime().toString() || new Date().getTime().toString(),
                // isSalesReturnKey: "",
                // itemId: "",
                // name: i?.name || "",
                // price: i?.price?.toString() || "",
                // quantity: i?.quantity?.toString() || "",
                // subtitle: i.subtitle || "",
                // updateDate: new Date().getTime().toString()
                itemId: i?.itemId || "",
                itemAddedDate: new Date().getTime().toString() || "",
                price: i?.price?.toString() || "",
                quantity: i?.quantity?.toString() || "",
            }));
        };


        const data = {
            uniqueID: id,
            // address: invoiceData?.address?.toString() || "",
            // companyId: invoiceData?.companyId?.toString() || "",
            // creationDate: new Date(invoiceData.creationDate).getTime().toString() || new Date().getTime().toString(),
            // customInvoiceId: "",
            // customer: invoiceData?.customer?.toString() || "",
            // customerGSTNo: invoiceData?.customerGSTNo?.toString() || "",
            // date: new Date(invoiceData.creationDate).getTime().toString() || new Date().getTime().toString(),
            // discountAmount: invoiceData?.discountAmount?.toString() || "0.00",
            // discountPercetage: invoiceData?.discountPercetage?.toString() || "0",
            // dueDate: new Date(parseInt(invoiceData?.dateDue)).getTime().toString() || new Date().getTime().toString(),
            // email: invoiceData?.email.toString() || "",
            // gstAmount: invoiceData?.gstAmount?.toString() || "0.00",
            // pstAmount: invoiceData?.pstAmount?.toString() || "0.00",
            // pstPercentage: invoiceData?.pstPercentage?.toString() || "0",
            pstAmount: invoiceData?.pstAmount?.toString() || "0.00",
            pstPercentage: invoiceData?.pstPercentage?.toString() || "0",
            // gstPercetage: invoiceData?.gstPercentage?.toString() || "0",
            // id: invoiceData?.id?.toString() || "",
            // invoiceId: invoiceData?.invoiceId?.toString() || "",
            // isigst: invoiceData?.isigst?.toString() || "false",
            // items: formatItems(invoiceData?.items),
            // note: invoiceData?.note?.toString() || "",
            // paidFlagKey: invoiceData?.isPaid?.toString() || "false",
            // phone: invoiceData?.phone?.toString() || "",
            // totalAmount: invoiceData?.totalAmount?.toString() || "",
            // updateDate: new Date().getTime().toString(),
            // platform: "website",
            // version: 'website',
            companyId: invoiceData?.companyId?.toString() || "",
            creationDate: invoiceData?.creationDate?.toString() || new Date().getTime().toString(),
            customInvoiceId: "",
            customerId: invoiceData?.customerId?.toString(),
            date: invoiceData?.date?.toString() || "",
            discountAmount: invoiceData?.discountAmount?.toString() || "0.00",
            discountPercetage: invoiceData?.discountPercetage?.toString() || "0",
            dueDate: invoiceData?.dateDue?.toString() || new Date().getTime().toString(),
            gstAmount: invoiceData?.gstAmount?.toString() || "0.00",
            pstAmount: invoiceData?.pstAmount?.toString() || "0.00",
            pstPercentage: invoiceData?.pstPercentage?.toString() || "0",
            gstPercetage: invoiceData?.gstPercentage?.toString() || invoiceData?.gstPercetage?.toString() || "0",
            id: invoiceData?.id?.toString() || "",
            invoiceId: invoiceData?.invoiceId?.toString() || "",
            isigst: invoiceData?.isigst || invoiceData?.igst == true ? "true" : "false",
            note: invoiceData?.note?.toString() || "",
            paidFlagKey: invoiceData?.isPaid ? "true" : "false",
            platform: "website",
            totalAmount: invoiceData?.totalAmount?.toString() || "",
            updateDate: invoiceData?.creationDate?.toString() || new Date().getTime().toString(),
            version: process.env.REACT_APP_VERSION,
            items: formatItems(invoiceData?.items),
            shippingaddress: invoiceData?.shippingaddress || "",
            currency: invoiceData?.currency?.toString() || "",
            // country: invoiceData?.country?.toString() || "",
            // countryCode: invoiceData?.countryCode?.toString() || "",
        }

        if (invoiceIndex !== -1) {
            existingData[invoiceIndex] = data;
        } else {
            // If invoice doesn't exist, add it
            // existingData.push(data);
        }

        // Save updated invoices back to localStorage
        localStorage.setItem("LOCAL_INVOICES", JSON.stringify(existingData));


        setTimeout(() => {
            dispatch({ type: actionType.GUESTMODELPOPUP, payload: true });
        }, 5000);

        // Fetch updated invoice data
        await GetInvoiceDataLocal(state, dispatch);

        return { success: true, message: "Invoice updated successfully!" };
    } catch (error) {
        return { success: false, message: error };
    }
};

export default EditInvoiceDataInLocal;
